import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const reasons = [
  {
    title: "We Map Moisture, Not Just Visible Water",
    detail:
      "Using thermal imaging and professional moisture meters, we identify hidden water migration before it becomes a bigger problem. We document moisture readings throughout the drying process — not just \"before\" and \"after.\"",
  },
  {
    title: "We Understand Insurance Documentation",
    detail:
      "Ben worked as a public adjuster for 10 years handling complex commercial claims. He knows what adjusters need to see, what questions they'll ask, and how to document cause, scope, and mitigation decisions. We provide Xactimate estimates that match carrier pricing databases.",
  },
  {
    title: "We Use Professional Drying Science",
    detail:
      "Structural drying isn't just \"run fans until it feels dry.\" We use psychrometric calculations, dehumidification strategy, air movement placement, and continuous monitoring. We follow IICRC S500 standards for water damage and S520 standards when mold concerns exist.",
  },
  {
    title: "We're Local and Owner-Led",
    detail:
      "No call centers. No franchise protocols. No out-of-state dispatch. Ben Jernigan responds directly to New Braunfels, San Marcos, Seguin, and Canyon Lake emergencies. You get 20+ years of restoration experience, not a new technician following a checklist.",
  },
  {
    title: "We Document for the Claim",
    detail:
      "Every WTR job includes moisture readings, equipment logs, photo documentation, thermal images, and written summaries. Many jobs also include 3D Matterport scans and Concerto cloud-based drying documentation. Your claim file is complete from day one.",
  },
];

export const WhyChooseSection = () => {
  return (
    <section className="py-8 bg-gradient-to-b from-wtr-warm to-background">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="text-xl md:text-2xl font-bold text-wtr-gray mb-1 text-center">
          Water Damage Mitigation Built on Speed, Science, and Documentation
        </h2>
        <p className="text-sm text-wtr-gray-light mb-4 text-center">
          Here's what most homeowners don't understand: water damage isn't just what you can see. Water migrates behind walls, under flooring, into insulation, and through structural cavities. If you only dry what's visible, you're setting up for mold growth, structural damage, and claim disputes.
        </p>
        <p className="text-sm font-semibold text-wtr-gray mb-4 text-center">
          Here's what separates WTR from generic restoration companies:
        </p>
        <ul className="space-y-3">
          {reasons.map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <Check className="w-5 h-5 text-wtr-blue shrink-0 mt-0.5" />
              <p className="text-sm text-wtr-gray">
                <strong>{item.title}.</strong>{" "}
                <span className="text-wtr-gray-light">{item.detail}</span>
              </p>
            </li>
          ))}
        </ul>
        <div className="mt-4 text-center">
          <Link to="/process" className="text-sm font-semibold text-wtr-blue hover:underline">
            Learn more about our process →
          </Link>
        </div>
      </div>
    </section>
  );
};
